export default __webpack_public_path__ + "static/desktop-app-mobile-3f0dc90a0882f8c20b379ac4e174dbd8.png";